import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Questions } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class QuestionsModule extends VuexModule {
    @Action
    [Questions.findPageQuestions](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/questions/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Questions.saveQuestions](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/questions/save`, values,{ onUploadProgress: onUploadProgress })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [Questions.deleteQuestions](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.delete(`/questions/delete/${values}`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}